import ApiServiceBase from "@/services/api/apiServiceBase";

/** Changelog endpoint is not on the PWA app contract. */
export class ChangeLogService extends ApiServiceBase {

    public async get(_version?: string): Promise<any[]> {
        return [];
    }
}
